import { useState, type FC, useRef } from 'react'

import styled from '@emotion/styled'

import useModal from '@segment/matcha/components/Modal/useModal'

import Media from '@segment/matcha/components/Media'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import ProductTourModal from './ProductTourModal'
import { DesktopImageCta, MobileImageCta } from './ImageCta'

const HEADING = `Want a tour of Twilio Segment?`
const WantATour: FC = () => {
  const modalRef = useRef(null)
  const modalOpenState = useState(false)
  const [opened] = modalOpenState
  const { getControlOpenProps, getControlCloseProps } = useModal(modalRef, modalOpenState)
  return (
    <>
      <Heading variant="h3">{HEADING}</Heading>
      <Media lessThan="md">
        <MobileImageCta />
      </Media>
      <Media greaterThanOrEqual="md">
        <DesktopImageCta {...getControlOpenProps()} />
      </Media>
      <ProductTourModal opened={opened} getControlCloseProps={getControlCloseProps} ref={modalRef} />
    </>
  )
}

const Heading = styled(CopyText.Heading)`
  text-align: center;
`

export default WantATour
